function QuizDescriptionLayout({ children }) {
  return <div className="quiz-description-layout">{children}</div>;
}

export default QuizDescriptionLayout;
